import React, { useEffect, useRef, useState } from 'react';
import TextField from '@material-ui/core/TextField';
import { getIn } from 'formik';
import notifications from 'lib/notifications';
import CloseIcon from 'mdi-react/CloseIcon';
import MUITextField from 'common/MUIComponents/TextField';
import { loadMapplsSearchPlugin } from 'lib/mappls';

const FormikMaterialTextField = (props) => {
  const {
    field,
    form: { touched, errors, values },
    variant,
    disabled,
    cb,
    isMarketView,
    // Opt-in. Address forms must still resolve to a village/town, but a radius search
    // only needs an origin point, so a state or district centroid is perfectly valid.
    allowAreaLevel,
    isFarmerUser,
    ...rest
  } = props;

  const hasError = !!(getIn(touched, field.name) && getIn(errors, field.name));
  const errText = hasError ? getIn(errors, field.name) : '';

  const [inputValue, setInputValue] = useState('');
  const inputIdRef = useRef(`mappls-search-${Math.random().toString(36).slice(2)}`);
  const cbRef = useRef(cb);
  const isMarketViewRef = useRef(isMarketView);
  const allowAreaLevelRef = useRef(allowAreaLevel);

  useEffect(() => {
    cbRef.current = cb;
    isMarketViewRef.current = isMarketView;
    allowAreaLevelRef.current = allowAreaLevel;
  }, [cb, isMarketView, allowAreaLevel]);

  useEffect(() => {
    setInputValue(field.value);
    if (!field.value && values?.location_code) {
      setInputValue(values?.location_code);
    }
  }, [field.value, values]);

  const handleInputChange = (e) => {
    let value = e.target.value;
    setInputValue(value);
  };

  useEffect(() => {
    let isMounted = true;

    loadMapplsSearchPlugin()
      .then((mappls) => {
        const inputElement = document.getElementById(inputIdRef.current);
        if (!isMounted || !inputElement || !mappls?.search) {
          return;
        }

        const optional_config = {
          location: [28.61, 77.23],
          bridge: false,
          tokenizeAddress: true,
          geolocation: false,
        };

        new mappls.search(inputElement, optional_config, function (data) {
          if (!isMounted) {
            return;
          }

          console.log('mappls data >>', data);

          if (data && !Object.prototype.hasOwnProperty.call(data, 'error')) {
            const selectedLocation = Array.isArray(data) ? data[0] : null;
            const shouldUpdateMarketValue = isMarketViewRef.current;
            // A state or district result carries no village/city/subDistrict token, so the
            // town-level check below rejected it and searching "Karnataka" only ever produced
            // an error. Callers that just need an origin point opt in via allowAreaLevel and
            // accept anything Mappls can resolve to a place (eLoc -> lat/long).
            const tokens = data[0]?.addressTokens;
            const isTownLevel =
              !!tokens?.district && (!!tokens?.village || !!tokens?.city || !!tokens?.subDistrict);
            const isResolvablePlace = !!data[0]?.eLoc;
            if (!(isTownLevel || (allowAreaLevelRef.current && isResolvablePlace))) {
              notifications.show({
                type: 'error',
                message: 'Village or Town not found. Please search your Village/ Town again',
                key: 'req-form',
              });
              shouldUpdateMarketValue ? setInputValue(selectedLocation?.placeName) : null;
              cbRef.current && cbRef.current({});
            } else {
              shouldUpdateMarketValue
                ? setInputValue(`${selectedLocation?.placeName}, ${selectedLocation?.placeAddress}`)
                : null;
              cbRef.current && cbRef.current(data);
            }
          }
        });
      })
      .catch((err) => {
        console.error('Mappls search failed to load', err);
      });

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <div style={{ position: isMarketView && 'relative' }}>
      {isFarmerUser ? (
        <MUITextField
          size={props.size || 'medium'}
          id={inputIdRef.current}
          className={props?.className ? props.className : 'search-outer form-control as-input'}
          placeholder={'Search landmark / village / town'}
          label={props.label}
          value={inputValue}
          onChange={(newValue) => setInputValue(newValue)}
          disabled={disabled}
          {...rest}
        />
      ) : (
        <>
          <TextField
            {...rest}
            variant={variant || 'outlined'}
            size="small"
            type="text"
            id={inputIdRef.current}
            name={inputIdRef.current}
            className={props?.className ? props.className : 'search-outer form-control as-input'}
            placeholder={'Search landmark / village / town'}
            label={props.label}
            required=""
            spellCheck="false"
            value={inputValue}
            onChange={handleInputChange}
            disabled={disabled}
            style={{ backgroundColor: 'var(--unnamed-color-ffffff)', height: '40px' }}
          />
          {isMarketView && inputValue !== '' && (
            <div style={{ position: 'absolute', right: '5px', top: '7px', zIndex: 1000000, backgroundColor: 'white' }}>
              <CloseIcon
                style={{ cursor: 'pointer' }}
                onClick={() => {
                  setInputValue('');
                }}
              />
            </div>
          )}
          <span
            style={{
              color: 'var(--unnamed-color-f44336)',
              fontSize: 'var(--fs-base__three)',
              fontFamily: 'var(--unnamed-font-segoeUI)',
            }}>
            {errors.location_code}
          </span>
        </>
      )}
    </div>
  );
};

export default FormikMaterialTextField;
